import React, { Component } from 'react';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CurrencyConverter from '../../CurrencyConverter';
import Link from '../../Link';
import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import Loader from '../../Loader/Loader';

//graphQL
import getAllPayoutsQuery from './getAllPayoutsQuery.graphql';
import { updatePayoutStatus } from '../../../actions/updatePayoutStatus';
import { withQuery } from '../../../hoc/withGraphql';
import formatReservationState from '../../../helpers/formatReservationState';
import { getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';

import s from './PayoutManagement.css';
import messages from '../../../locale/jsonMessages';

class PayoutManagement extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      typing: false,
      typingTimeout: 0
    }
    this.paginationData = this.paginationData.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleHoldPayout = this.handleHoldPayout.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { getAllPayouts: { completed, loading } } = nextProps;
    const { searchList, currentPage } = this.state;
    const { getAllPayouts: { refetch } } = this.props;
    let variables = { currentPage, searchList };
    if (completed && !loading) {
      refetch(variables);
    }
  }

  paginationData(currentPage) {
    const { getAllPayouts: { refetch }, setStateVariable } = this.props;
    let variables = { currentPage };
    setStateVariable(variables);
    refetch(variables);
  }

  handleClick(searchList) {
    const { getAllPayouts: { refetch }, setStateVariable } = this.props;
    const { currentPage } = this.state;
    let variables = {
      currentPage: 1,
      searchList: searchList
    };
    setStateVariable(variables);
    refetch(variables);
  }

  handleSearchChange = (e) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleClick(self.state.searchList);
      }, 450)
    });
  }

  async handleHoldPayout(e, id, currentPage) {
    const { updatePayoutStatus, getAllPayouts: { refetch }, setStateVariable } = this.props;
    let isHold = e.target.value;
    isHold = isHold == "true" ? true : false;
    await updatePayoutStatus(id, isHold);
    let variables = { currentPage };
    setStateVariable(variables);
    refetch(variables);
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.reservationId) },
      { data: formatMessage(messages.codeLabel) },
      { data: formatMessage(messages.adminListTitle) },
      { data: formatMessage(messages.ownerNameLabel) },
      { data: formatMessage(messages.payoutLabel) },
      { data: formatMessage(messages.claimAmount) },
      { data: formatMessage(messages.reservationStatus) },
      { data: formatMessage(messages.payoutStatus) },
      { data: formatMessage(messages.claimStatus) },
      { data: formatMessage(messages.holdPayout) },
      { data: formatMessage(messages.details) },
    ]
  };

  tbody = (props) => {
    const { getAllPayouts: { getAllPayoutReservation }, currentPage, locale } = props;
    const { formatMessage } = this.props.intl;

    return getAllPayoutReservation?.reservationData.map(item => {
      let payoutAmount = 0;
      let status, claimStatus;
      if (item.hostTransaction && item.hostTransaction.id) {
        status = 'completedLabel';
      } else if (item.hostFailedTransaction && item.hostFailedTransaction.id) {
        status = 'failed';
      } else if (item.hostPayout == null && item.hostTransaction == null && item.hostFailedTransaction == null) {
        status = 'noPayoutMethod';
      } else if (item.hostTransaction == null && item.hostFailedTransaction == null && item.reservationState == 'completed') {
        status = 'messageStatus5';
      } else if (item.reservationState == 'cancelled' && item.cancellationDetails && (item.cancellationDetails.payoutToHost == 0 || item.cancellationDetails.payoutToHost < 0)) {
        status = 'closedLabel'
      } else if (item.reservationState == 'cancelled' && item.cancellationDetails && item.cancellationDetails.payoutToHost > 0 && item.hostTransaction == null && item.hostFailedTransaction == null) {
        status = 'messageStatus5';
      } else {
        status = 'messageStatus5';
      }
      if (item.reservationState == 'cancelled') {
        payoutAmount = item.cancellationDetails ? item.cancellationDetails.payoutToHost : 0;
      } else {
        if (item?.promoCodeType === "admin") {
          payoutAmount = (item.total + item.promoDiscount) - item.hostServiceFee;
        } else {
          payoutAmount = item.total - item.hostServiceFee;
        }

      }

      if (item.claimPayout > 0 && item.claimTransaction && item.claimTransaction.id) {
        claimStatus = 'completedLabel';
      }
      else if (item.claimPayout > 0 && item.claimFailedTransaction && item.claimFailedTransaction.id) {
        claimStatus = 'failed';
      }
      else if (item.claimPayout > 0 && !item.hostPayout && !item.hostTransaction && !item.hostFailedTransaction) {
        claimStatus = 'noPayoutMethod';
      }
      else if (item.securityDeposit > 0) {
        claimStatus = 'messageStatus5';
      } else if (item.securityDeposit == 0 || item.claimStatus == 'fullyRefunded') {
        claimStatus = 'closedLabel'
      }

      let dynamicTitleContent, dynamicTitle;
      if (item?.dynamicListTitle) {
        dynamicTitleContent = JSON.parse(item?.dynamicListTitle)
        dynamicTitle = getDynamicTitle({ data: dynamicTitleContent, locale, id: item?.listId });
      }


      return {
        id: item.id,
        data: [
          { data: item.id },
          {
            data: item.confirmationCode
          },
          {
            data: (item.listData || item.listTitle) ? <a href={"/cars/" + item.listId} target='_blank'>
              {dynamicTitle || (item.listTitle ? item.listTitle : item.listData.title)}
            </a> : formatMessage(messages.dataMissing)
          },
          {
            data: item?.hostData?.firstName

          },
          {
            data: <CurrencyConverter
              amount={payoutAmount}
              from={item.currency}
            />
          },
          {
            data: <CurrencyConverter
              amount={item.claimPayout}
              from={item.currency}
            />
          },
          {
            data: formatReservationState(item.reservationState, { formatMessage })
          },
          {
            data: status && status === 'failed' ? <div><Link to={'/siteadmin/failed-payout/' + item.id}>{formatMessage({ id: status })}</Link></div> : formatMessage({ id: status })
          },
          {
            data: claimStatus && claimStatus === 'failed' ? <div><Link to={'/siteadmin/failed-payout/' + item.id}>{formatMessage({ id: claimStatus })}</Link></div> : formatMessage({ id: claimStatus })
          },
          {
            data:
              ((item && item.hostTransaction) || item.reservationState === 'expired'
                || item.reservationState === 'declined') ? ' - ' : <div>
                <select className='commonTableInsideSelect' value={item.isHold} onChange={(e) => this.handleHoldPayout(e, item.id, currentPage)}>
                  <option value={true}>{formatMessage(messages.yesLabel)}</option>
                  <option value={false}>{formatMessage(messages.noLabel)}</option>
                </select></div>
          },
          {
            data: <div><Link to={"/siteadmin/viewpayout/" + item.id + '/payout'} >
              <FormattedMessage  {...messages.viewLabel} />
            </Link></div>
          }
        ]
      }
    })
  }


  render() {
    const { getAllPayouts: { loading, getAllPayoutReservation } } = this.props;
    const { currentPage } = this.props;
    const { formatMessage } = this.props.intl;

    if (loading) {
      return <Loader type={"text"} />
    }

    return (
      <div>
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          title={formatMessage(messages.payOutManagement)}
          isSearch
          onSearch={this.handleSearchChange}
        />
        {
          !loading && getAllPayoutReservation?.reservationData?.length > 0 &&
          <CustomPagination
            total={getAllPayoutReservation.count}
            currentPage={currentPage}
            defaultCurrent={1}
            defaultPageSize={10}
            change={this.paginationData}
            paginationLabel={formatMessage(messages.payoutsLabel)}
          />
        }
      </div >
    )
  }
}

const mapState = (state) => ({
  completed: state.payout.completed,
  loading: state.payout.loading,
  locale: state?.intl?.locale
});

const mapDispatch = {
  updatePayoutStatus,
};
export default compose(injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
  withQuery(getAllPayoutsQuery, {
    name: 'getAllPayouts',
    options: (props) => ({
      variables: {
        currentPage: 1,
        searchList: ''
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(PayoutManagement);